import { v4 as uuid } from 'uuid';
import './BuilderQueues.scss';
import { QueueManagementConstants, QueuesTracks } from 'modules/application/detail/attendance/queueManagement/QueueManagementConstants';
import { ToastType } from 'modules/application/misc/ToastService';
import { debounce } from 'data/function';
import { AttendanceConstants } from 'modules/application/detail/attendance/AttendanceConstants';
export class BuilderQueuesController {
    static $inject = ['DeskConfigurationService', 'AlertService', 'SegmentService', 'QueuesService', '$translate', 'PermissionsService', 'TeamService'];
    constructor(DeskConfigurationService, AlertService, SegmentService, QueuesService, $translate, PermissionsService, TeamService) {
        'ngInject';
        this.DeskConfigurationService = DeskConfigurationService;
        this.AlertService = AlertService;
        this.SegmentService = SegmentService;
        this.QueuesService = QueuesService;
        this.$translate = $translate;
        this.PermissionsService = PermissionsService;
        this.TeamService = TeamService;
        this.teams = [];
        this.currentState = QueueManagementConstants.STATES.VIEWING;
        this.attendantsTake = 999999;
        this.take = 100;
        this.skip = 0;
        this.filter = '';
        this.queueName = '';
        this.validQueueName = true;
        this.nameRequired = true;
        this.inputTextSearchQueues = '';
        this.isManagerView = true;
        this.isViewing = QueueManagementConstants.STATES.VIEWING;
        this.isAdding = QueueManagementConstants.STATES.ADDING;
        this.isEdit = QueueManagementConstants.STATES.EDITING;
        this.searchQueue = async (event) => {
            this.setIsLoading(true);
            this.inputTextSearchQueues = event.detail.value;
            if (this.inputTextSearchQueues) {
                this.filterQueues();
            }
            else {
                this.filteredQueues = this.allQueues.slice();
                this.filteredQueuesCount = this.allQueuesCount;
                this.checkLoadMoreStatus();
            }
            this.setIsLoading(false);
            this.SegmentService.createBotTrack(QueuesTracks.QUEUES_SEARCHED, this.application, this.trackPayload);
        };
        this.changeQueueName = async (event) => {
            this.queueName = await event?.target.value.trim();
            this.validQueueName = true;
            this.nameRequired = false;
            if (this.queueName.length === 0) {
                this.nameRequired = true;
            }
        };
    }
    async $onInit() {
        this.allQueues = [];
        this.filteredQueues = [];
        this.debouncedSearch = debounce(this.searchQueue, 500);
        this.hasDeskWritePermission = await this.PermissionsService.hasPermissions(QueueManagementConstants.WRITE, QueueManagementConstants.DESK);
        this.trackPayload = { source: QueuesTracks.SOURCE.BUILDER };
        this.SegmentService.createBotTrack(QueuesTracks.PAGE_OPENED, this.application, this.trackPayload);
        await this.getAllAttendants();
        await this.getQueues();
    }
    setCurrentState(state) {
        this.currentState = state;
    }
    setIsLoading(isLoading) {
        this.isLoading = isLoading;
    }
    async filterQueues() {
        try {
            const { items, total } = await this.QueuesService.filterQueues(this.inputTextSearchQueues, this.skip, this.take);
            if (this.hasAnyDistinctQueue(this.filteredQueues, items)) {
                const queues = this.mapQueues(items);
                this.filteredQueues = queues;
            }
        }
        catch (e) {
            this.filteredQueues = [];
        }
        finally {
            this.filteredQueuesCount = this.filteredQueues.length;
            this.checkLoadMoreStatus();
        }
    }
    hasAnyDistinctQueue(queues, queuesToCompare) {
        if (queues.length != queuesToCompare.length) {
            return true;
        }
        return queues.some((q) => queuesToCompare.find((qtc) => qtc.id == q.id) === undefined);
    }
    mapQueues(items) {
        let queues;
        queues = items ? items.map((item) => {
            item.numberAttendants = (this.teams.filter((a) => (a.teams.includes(item.name)))).length;
            return item;
        }) : [];
        return queues;
    }
    checkLoadMoreStatus() {
        if (this.isFilterMode()) {
            this.canLoadMore = this.filteredQueues.length < this.filteredQueuesCount;
        }
        else {
            this.canLoadMore = this.allQueues.length < this.allQueuesCount;
        }
    }
    isFilterMode() {
        if (this.inputTextSearchQueues == undefined || this.inputTextSearchQueues === '') {
            return false;
        }
        return true;
    }
    async clearSearch() {
        this.inputTextSearchQueues = '';
        this.currentState = QueueManagementConstants.STATES.VIEWING;
        this.filteredQueues = this.allQueues.slice();
        this.filteredQueuesCount = this.allQueuesCount;
        this.checkLoadMoreStatus();
        this.SegmentService.createBotTrack(QueuesTracks.CLEAR_SEARCH, this.application, this.trackPayload);
    }
    async getQueues() {
        if (this.isLoading) {
            return;
        }
        this.setIsLoading(true);
        this.canLoadMore = false;
        try {
            const { items, total } = await this.QueuesService.getQueues(this.skip, this.take);
            this.allQueuesCount = total;
            this.allQueues = this.mapQueues(items);
            this.filteredQueues = this.allQueues.slice();
            this.allQueuesCount = total;
            this.filteredQueuesCount = this.allQueuesCount;
        }
        catch (e) {
            this.allQueues = [];
            this.filteredQueues = [];
        }
        finally {
            this.setIsLoading(false);
            this.checkLoadMoreStatus();
        }
    }
    async getAllAttendants() {
        if (this.isLoading) {
            return;
        }
        this.setIsLoading(true);
        try {
            const { items } = await this.TeamService.getAttendants(this.filter, this.skip, this.attendantsTake);
            const team = items;
            this.teams.push(...team);
        }
        catch (e) {
            this.teams = [];
        }
        this.setIsLoading(false);
    }
    async goToAddQueue() {
        if (this.currentState === QueueManagementConstants.STATES.ADDING || this.currentState === QueueManagementConstants.STATES.EDITING) {
            return;
        }
        const title = this.$translate.instant('queue-management.queues.queueName');
        const newQueue = {
            id: uuid(),
            title: `${title} ${this.filteredQueues.length + 1}`,
            isActive: true,
            opened: true,
        };
        this.queue = newQueue;
        this.queueName = '';
        this.validQueueName = true;
        this.SegmentService.createBotTrack(QueuesTracks.ADD_QUEUE_CLICKED, this.application, this.trackPayload);
        this.setCurrentState(QueueManagementConstants.STATES.ADDING);
    }
    addQueue() {
        if (this.currentState === QueueManagementConstants.STATES.ADDING || this.currentState === QueueManagementConstants.STATES.EDITING) {
            return;
        }
        this.SegmentService.createBotTrack(QueuesTracks.ADD_QUEUE_CLICKED, this.application);
        if (this.filteredQueues.length == 0) {
            this.filteredQueues.push({});
        }
        else {
            const lastQueue = this.filteredQueues[this.filteredQueues.length - 1];
            if (lastQueue.hasOwnProperty('id')) {
                this.filteredQueues.push({});
            }
        }
    }
    clearQueueList(data) {
        if (data.id) {
            return;
        }
        this.filteredQueues.pop();
    }
    async saveQueue(data) {
        let queue;
        let toastMessageReference;
        let toastType;
        queue = {
            id: uuid(),
            ...data,
        };
        toastMessageReference = this.currentState === QueueManagementConstants.STATES.ADDING
            ? 'queue-management.queues.confirmAddQueue'
            : 'queue-management.queues.confirmEdit';
        try {
            await this.QueuesService.save(queue);
            this.SegmentService.createBotTrack(QueuesTracks.QUEUE_SAVED, this.application, this.trackPayload);
            toastType = ToastType.Success;
            return true;
        }
        catch (ex) {
            if (ex.code === 23) {
                toastMessageReference = 'utils.errorMsg.177';
                toastType = ToastType.Danger;
            }
            else {
                toastMessageReference = 'modules.application.detail.attendance.queue-management.warning';
                toastType = ToastType.Danger;
            }
            return false;
        }
        finally {
            await this.QueuesService.showToast(toastMessageReference, toastType);
            this.setIsLoading(false);
            this.queueName = queue.name;
            this.queueId = queue.id;
            this.queue = queue;
            this.getQueues();
        }
    }
    async createQueue() {
        const title = this.queueName;
        await this.getQueues();
        const queueFilter = this.allQueues.find(queue => {
            return queue.name.toLowerCase() === title.toLowerCase();
        });
        if (queueFilter) {
            if (!this.queue.id || this.queue.id != queueFilter.id) {
                this.validQueueName = false;
                return;
            }
        }
        if (AttendanceConstants.DIRECT_TRANSFER_TEAM.toLowerCase() === title.toLowerCase()) {
            this.QueuesService.showToast('queue-management.queues.warnningCreateQueue', ToastType.Warning);
            return;
        }
        this.queue.name = title;
        const success = await this.saveQueue(this.queue);
        if (success) {
            this.goToChangeMode(this.queue);
        }
    }
    async confirmDelete(queue) {
        if (queue.numberAttendants > 0) {
            let toastMessageReference;
            let toastType;
            toastType = ToastType.Danger;
            toastMessageReference = 'queue-management.queues.warnningDeleteAttendant';
            await this.QueuesService.showToast(toastMessageReference, toastType);
            return;
        }
        try {
            const modalTitle = await this.$translate('modules.application.detail.attendance.queue-management.builder.confirmDeleteTitle');
            const modalBody = await this.$translate('modules.application.detail.attendance.queue-management.builder.confirmDeleteBody', { name: queue.name });
            const confirm = await this.$translate('utils.forms.exclude');
            const cancel = await this.$translate('utils.forms.cancel');
            await this.AlertService.show({
                title: modalTitle,
                body: modalBody,
                variant: 'delete',
                icon: 'trash',
                buttons: {
                    cancel: cancel,
                    confirm: confirm,
                },
                callback: {
                    cancelButtonAction: () => { },
                    confirmButtonAction: () => this.delete(queue),
                },
            });
        }
        catch (e) {
            console.error(e);
        }
    }
    async delete(queue) {
        let toastMessageReference;
        let toastType;
        try {
            this.setIsLoading(true);
            this.QueuesService.delete(queue);
            this.filteredQueues = this.filteredQueues.filter(obj => obj.id !== queue.id);
            toastMessageReference = 'queue-management.queues.confirmRemoveQueue';
            toastType = ToastType.Success;
            await this.getQueues();
            this.SegmentService.createBotTrack(QueuesTracks.QUEUE_DELETED, this.application, this.trackPayload);
        }
        catch (e) {
            toastMessageReference = 'utils.errorMsg.113';
            toastType = ToastType.Danger;
        }
        finally {
            this.setIsLoading(false);
            await this.QueuesService.showToast(toastMessageReference, toastType);
        }
    }
    async loadMore() {
        if (this.isFilterMode()) {
            let queues;
            const { items, total } = await this.QueuesService.filterQueues(this.inputTextSearchQueues, this.filteredQueues.length, this.take);
            queues = this.mapQueues(items);
            this.filteredQueues.push(...queues);
            this.filteredQueuesCount = total;
            this.checkLoadMoreStatus();
        }
        else {
            const { items, total } = await this.QueuesService.getQueues(this.allQueues.length, this.take);
            let queues;
            queues = this.mapQueues(items);
            this.allQueues.push(...queues);
            this.allQueuesCount = total;
            this.filteredQueuesCount = total;
            this.filteredQueues = this.allQueues.slice();
            this.checkLoadMoreStatus();
        }
    }
    goToChangeMode(queue) {
        this.setCurrentState(this.isViewing);
        this.changeMode({ $queue: queue });
    }
}
BuilderQueuesController.$inject = ['DeskConfigurationService', 'AlertService', 'SegmentService', 'QueuesService', '$translate', 'PermissionsService', 'TeamService'];
